export { default } from "./AppointmentRescheduleDialog";

export enum AppointmentRescheduleSteps {
    Availability = 0,
    Confirmation = 1,
}
